var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-32"},[_c('inactive-link',{attrs:{"message":'This link is no longer active. Please contact the person who sent it to you for more information.'}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }